import { Controller } from '@hotwired/stimulus'
import { dispatchCustomEvent } from '../../../helpers/custom_events_helper'

// TODO: Make this keyboard accessible
export default class extends Controller {
  static targets = ['card']
  // TODO: We should use the snapshotId now
  static values = {
    cycleId: Number,
    snapshotId: Number
  }

  connect() {
    this.updateActiveCardFromUrl()

    window.addEventListener('galette:sidebar:close', this.handleSidebarClose)
  }

  disconnect() {
    window.removeEventListener('galette:sidebar:close', this.handleSidebarClose)
  }

  handleSidebarClose = (event) => {
    // Only react to the sidebar this timeline is rendered inside of
    if (event?.detail?.sidebar && !event.detail.sidebar.contains(this.element)) return

    this.setActiveCard(this.cardTargets[0])
  }

  updateActiveCardFromUrl() {
    // Check URL for snapshot_id and activate the corresponding card
    const url = new URL(window.location.href)
    const snapshotId = url.searchParams.get('snapshot_id')

    if (snapshotId) {
      // Find the card with this snapshot_id
      const matchingCard = this.cardTargets.find(card => {
        const cardSnapshotId = card.dataset['reportingCycles-HistoryTimelineSnapshotIdParam']
        return cardSnapshotId === snapshotId
      })

      if (matchingCard) {
        this.setActiveCard(matchingCard)
      }
    } else {
      // No snapshot_id, activate the "Current" card
      this.setActiveCard(this.cardTargets[0])
    }
  }

  selectCard(event) {
    const clickedCard = event.currentTarget

    // Only allow clicking on cards with data-clickable="true"
    if (clickedCard.dataset.clickable !== 'true') {
      return
    }

    this.setActiveCard(clickedCard)

    // Get snapshot_id from action params
    const snapshotId = event.params.snapshotId

    // Dispatch event for snapshot manager to handle URL and frame reloading
    dispatchCustomEvent(window, 'reporting-cycle:snapshot-changed', {
      detail: { snapshotId: snapshotId || '' }
    })
  }

  setActiveCard(activeCard) {
    // Remove active class from all clickable cards
    this.cardTargets.forEach(card => {
      if (card.dataset.clickable !== 'true') {
        return
      }
      card.classList.remove('history-timeline__card--active')
      card.classList.add('history-timeline__card--inactive')
    })

    // Add active class to the specified card and remove inactive
    activeCard.classList.remove('history-timeline__card--inactive')
    activeCard.classList.add('history-timeline__card--active')
  }
}
